import styled from "styled-components";

export const SlideMobilePositionModalLastContainerStyled = styled.div`
    flex-direction: column;
    align-items: center;

    text-align: center;
    font-weight: 300 ;
    font-size: 16px;
    line-height: 24px;

    p {
        margin-top: 8px;
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
    }

`